export default {
  gallery: {
    image: 'Imagem',
    close: 'Fechar',
    next: 'Próxima',
    previous: 'Anterior'
  }
}
